import {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from "reactstrap"
import CardRow from "../../../Styled/Card/CardRow.jsx"
import CardCol from "../../../Styled/Card/CardCol.jsx"


class FilterItSkills extends Component {
  static propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    requireSubmit: PropTypes.bool,
    value: PropTypes.arrayOf(PropTypes.string),
  }

  static defaultProps = {
    className: '',
    requireSubmit: true,
    value: [],
  }

  constructor(props) {
    super(props)

    this.state = {
      value: props?.value?.[0] ?? ''
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
      this.setState({value: this.props?.value?.[0] ?? ''})
    }
  }

  onChange = (event) => {
    const value = event.currentTarget.value
    this.setState({ value: value })

    if (!this.props.requireSubmit) {
      this.props.onChange({itSkills: [value]})
    }
  }

  onSubmitFilter = () => {
    const {value} = this.state

    this.props.onChange({
      itSkills: [value]
    })
  }

  render() {
    const {requireSubmit} = this.props

    return (
      <CardRow gap=".5rem" align="center">
        <CardCol flex={requireSubmit ? undefined : 1}>
          <Input
            type="text"
            value={this.state.value}
            name="itSkills"
            className={`filter-it-skills ${this.props.className}`}
            onChange={this.onChange}
            placeholder="Nom de l'outil"
          />
        </CardCol>
        {requireSubmit && (
          <CardCol>
            <button type={"button"} className="btn btn-secondary" onClick={this.onSubmitFilter}>
              OK
            </button>
          </CardCol>
        )}
      </CardRow>
    )
  }
}

export default FilterItSkills
